import React, { memo } from 'react';
import { useTrackSection } from '../utils/useTrackSection';
const painPoints = ['Llegás a la consulta sin una estructura clara y terminás resolviendo todo sobre la marcha.', 'Tenés varios pacientes en seguimiento, pero no siempre sabés qué revisar, qué ajustar o cómo ordenar la evolución de cada uno.', 'Sentís que tu consultorio depende demasiado de tu memoria, tus notas sueltas o lo que alcances a preparar ese día.', 'Querés atender mejor y cobrar con más seguridad, pero todavía no tenés un sistema profesional que respalde tu forma de trabajar.', 'Entre consultas, mensajes, planes, controles y organización, sentís que el consultorio se vuelve un caos difícil de sostener.'];
export function PainPoints() {
  useTrackSection('pain-points', 'Pain Points Section');
  return <section id="pain-points" className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(248,250,252) 0%, rgb(254,242,242) 10%, rgb(254,242,242) 85%, rgb(248,250,252) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-148">
      <div className="mx-auto max-w-4xl" data-id="element-149">
        {/* Section Title */}
        <p className="text-center text-xs sm:text-sm font-bold tracking-[2px] uppercase text-red-500 mb-2" data-id="element-150">
          ¿Te sentís identificado?
        </p>
        <h2 className="text-center text-2xl sm:text-3xl font-black text-gray-900 m-0 mb-2" data-id="element-151">
          Esto le pasa al 90% de las nutricionistas
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-6" data-id="element-152">
          No es falta de conocimiento. Es falta de un sistema.
        </p>

        {/* Pain Points Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8" data-id="element-153">
          {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2 bg-white border border-red-200 rounded-lg p-3 shadow-sm" data-id="element-154">
              <span className="text-red-500 text-base leading-5 shrink-0" data-id="element-155">
                ✗
              </span>
              <p className="text-xs sm:text-sm text-gray-800 m-0" data-id="element-156">{point}</p>
            </div>)}
        </div>

        {/* Bottom CTA */}
        <p className="text-center text-xl sm:text-2xl font-black text-green-700 m-0 mb-6" data-id="element-157">
          ¿Cuántas consultas más vas a seguir resolviendo sobre la marcha?
        </p>

        {/* Divider */}
        <div className="h-px w-full" style={{
        backgroundImage: 'linear-gradient(to right, rgba(255,255,255,0), rgb(34,197,94), rgba(255,255,255,0))'
      }} data-id="element-158" />
      </div>
    </section>;
}